import { environment } from '#environments';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Dtos } from '#models';

@Injectable({
  providedIn: 'root',
})
export class TranslationHistoryService {
  private http = inject(HttpClient);

  saveTranslationHistory(payload: Dtos.TranslationHistory) {
    return this.http.post<Dtos.TranslationHistory>(`${environment.apiUrl}/translationHistory`, payload);
  }
}
